module.exports = __webpack_public_path__ + "img/antes_despues_293.186c39df.png";